/* Maison TENYT — thème « Structure » */
(function () {
  'use strict';
  var T = window.TENYT || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var lastFocus = null;

  /* ---------- Formatage des prix ---------- */
  function group(intStr, sep) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = Number(cents) / 100;
    var parts = n.toFixed(2).split('.');
    var values = {
      amount: group(parts[0], ',') + '.' + parts[1],
      amount_no_decimals: group(String(Math.round(n)), ','),
      amount_with_comma_separator: group(parts[0], '.') + ',' + parts[1],
      amount_no_decimals_with_comma_separator: group(String(Math.round(n)), '.'),
      amount_with_space_separator: group(parts[0], ' ') + ',' + parts[1],
      amount_no_decimals_with_space_separator: group(String(Math.round(n)), ' '),
      amount_with_apostrophe_separator: group(parts[0], "'") + '.' + parts[1]
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return values[k] != null ? values[k] : values.amount; });
  }

  /* ---------- Calques : menu mobile et panier ---------- */
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var target = el.querySelector('[data-focus-start]') || el.querySelector('button, a');
    if (target) setTimeout(function () { target.focus(); }, 30);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function cartDrawer() { return $('[data-cart-drawer]'); }
  function onCartPage() { return document.body.classList.contains('template-cart'); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var menuBtn = t.closest('[data-menu-open]');
    if (menuBtn) {
      e.preventDefault();
      menuBtn.setAttribute('aria-expanded', 'true');
      openLayer($('[data-mnav]'));
      return;
    }
    if (t.closest('[data-menu-close]')) { closeLayer($('[data-mnav]')); return; }
    if (t.closest('[data-cart-open]') && cartDrawer() && !onCartPage()) {
      e.preventDefault();
      openLayer(cartDrawer());
      return;
    }
    if (t.closest('[data-cart-close]')) { closeLayer(cartDrawer()); return; }
    var change = t.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      changeLine(change.getAttribute('data-line'), parseInt(change.getAttribute('data-qty'), 10));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.layer.is-open').forEach(closeLayer);
  });

  /* ---------- Panier ---------- */
  function sectionsUrl() {
    var u = new URL(T.root || '/', window.location.origin);
    u.searchParams.set('sections', 'cart-drawer');
    return u.toString();
  }
  function refreshCart(open) {
    return fetch(sectionsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-panel]');
        var current = $('[data-cart-panel]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var countEl = doc.querySelector('[data-cart-total-count]');
        if (countEl) {
          var n = countEl.getAttribute('data-cart-total-count');
          $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; });
        }
        if (open) openLayer(cartDrawer());
      });
  }
  function changeLine(line, qty) {
    return fetch((T.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: qty })
    }).then(function () {
      if (onCartPage()) { window.location.reload(); return; }
      return refreshCart(false);
    });
  }

  /* ---------- Fiche produit : choix de taille + ajout au panier ---------- */
  function initProductForm(form) {
    var dataEl = form.querySelector('[data-product-json]');
    var idInput = form.querySelector('[data-variant-id]');
    var btn = form.querySelector('[data-add]');
    var label = form.querySelector('[data-add-label]');
    var scope = form.closest('[data-product-scope]') || document;
    var priceEl = scope.querySelector('[data-price]');
    var groups = $$('[data-option-index]', form);
    if (!dataEl || !groups.length) return;
    var variants = JSON.parse(dataEl.textContent);

    function match(sel) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    }
    function selected() {
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function update(pushUrl) {
      var sel = selected();
      groups.forEach(function (g, gi) {
        $$('input', g).forEach(function (input) {
          var test = sel.slice(); test[gi] = input.value;
          var m = match(test);
          input.closest('.opt__v').classList.toggle('is-out', !m || !m.available);
        });
      });
      var v = match(sel);
      if (!v) {
        btn.disabled = true; btn.setAttribute('data-available', 'false');
        label.textContent = 'Indisponible';
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.setAttribute('data-available', String(v.available));
      label.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (priceEl) priceEl.textContent = money(v.price);
      if (pushUrl && form.querySelector('[data-update-url-flag]')) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(null, '', u.toString());
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    update(false);
  }
  $$('[data-product-form]').forEach(initProductForm);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    fetch((T.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || "La pièce n'a pas pu être ajoutée au panier.");
          return refreshCart(true);
        });
      })
      .catch(function (x) {
        if (err) { err.textContent = x.message; err.hidden = false; }
      })
      .then(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.disabled = btn.getAttribute('data-available') === 'false';
        }
      });
  });
})();
